"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderContainer = exports.TypographyLink = exports.WhiteArrow = exports.ListButton = exports.Link = exports.SignInButton = exports.DropdownContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = __importDefault(require("../Button"));
const svg_components_1 = require("../../assets/svg-components");
const Typography_1 = __importDefault(require("../UI/Typography"));
exports.DropdownContainer = styled_components_1.default.div `
  position: absolute;
  top: ${props => props.theme.constants.myHaldexDropdown.top}px;
  margin-left: auto;
  margin-right: auto;
  right: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: ${props => props.theme.palette.BW_100};
  width: ${props => props.theme.constants.myHaldexDropdown.width}px;
  box-shadow: ${props => props.theme.attributes.boxShadow.myHaldexDropdown};
  border-radius: ${props => props.theme.attributes.borderRadius.xs}px;
  text-align: center;
  z-index: 1;
`;
exports.SignInButton = (0, styled_components_1.default)(Button_1.default) `
  margin: ${props => props.theme.spacing.s3}px ${props => props.theme.spacing.s4}px;
`;
exports.Link = styled_components_1.default.a `
  text-decoration: none;
  color: ${props => props.theme.palette.LIGHT_BLACK};
  display: inline-block;
  width: 100%;
  height: 100%;
  padding: ${props => props.theme.spacing.s3}px ${props => props.theme.spacing.s4}px;

  :hover {
    background: ${props => props.theme.palette.LIGHT_GRAY_20};
  }
`;
exports.ListButton = (0, styled_components_1.default)(Button_1.default) `
  padding: ${props => props.theme.spacing.s3}px ${props => props.theme.spacing.s4}px;
  border-bottom-left-radius: ${props => props.theme.spacing.s1}px;
  border-bottom-right-radius: ${props => props.theme.spacing.s1}px;

  :hover {
    background: ${props => props.theme.palette.LIGHT_GRAY_20};
  }
`;
exports.WhiteArrow = (0, styled_components_1.default)(svg_components_1.WhiteSolidArrow) `
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  z-index: 0;
  right: ${props => props.theme.spacing.s1}px;
  top: -${props => props.theme.constants.myHaldexDropdown.arrowTop}px;
`;
exports.TypographyLink = (0, styled_components_1.default)(Typography_1.default) `
  z-index: 1;

  ${props => (props === null || props === void 0 ? void 0 : props.first) &&
    `border-top-left-radius: ${props.theme.spacing.s1}px; border-top-right-radius: ${props.theme.spacing.s1}px;`}
`;
exports.LoaderContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.s5}px; 
`;
exports.default = {
    DropdownContainer: exports.DropdownContainer,
    SignInButton: exports.SignInButton,
    Link: exports.Link,
    ListButton: exports.ListButton,
    WhiteArrow: exports.WhiteArrow,
    TypographyLink: exports.TypographyLink
};
